import { Box } from '@chakra-ui/react'
import { type DataCompletenessType, colorMap, completenessIndicatorLayout } from './dataCompletenessIndicator.utils'

interface DataCompletenessDotProps {
  type: DataCompletenessType
}

export const DataCompletenessDot = ({ type }: DataCompletenessDotProps) => {
  const color = colorMap[type]
  return (
    <Box
      width={`${completenessIndicatorLayout.dotSizePx}px`}
      height={`${completenessIndicatorLayout.dotSizePx}px`}
      borderRadius={'50%'}
      bg={color}
    />
  )
}
